var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarRateBlack24Dp2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "star_rate_black_24dp (2)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 122",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 903",
    d: "m13.378 9.434-1.32-4.346a.9.9 0 0 0-1.715 0L9.014 9.434h-4a.9.9 0 0 0-.514 1.625l3.269 2.335-1.284 4.14a.9.9 0 0 0 1.4.979L11.2 16l3.314 2.523a.9.9 0 0 0 1.4-.979L14.627 13.4l3.273-2.332a.9.9 0 0 0-.521-1.625h-4z",
    transform: "translate(-.724 -.872)",
    style: {
      fill: "#dfdfdf"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRateBlack24Dp2);
export default __webpack_public_path__ + "static/media/star_rate_black_24dp (2).adb16212234f501ccd5878c0ecc24ee5.svg";
export { ForwardRef as ReactComponent };